import { observable, action, runInAction, autorun, flow, computed, toJS } from 'mobx';
import { Modal, Toast } from 'antd-mobile';
import _, { cloneDeep, intersection, result, union } from 'lodash';
import Util from 'utils';
import Config from 'config/Config';
import Stores from 'config/Stores';
import { func, object } from 'prop-types';
import { fetchData } from 'pubBiz/ActiveAdPopup/fetchData';
import { popupPositionMap, routeAuthCodeMap, ghObj, MallType, CardType } from 'utils/constants';
import { getAuthRouteList, isHasTagAuth, isHasRouteAuth } from 'utils/authUtil';
import RedEnvelopeRain from './components/RedEnvelopeRain/RedEnvelopeRainView';
import Serv from './ShopHomeServ';
import { t } from 'config/language/context';
import ToWeapp, { showToWeapp } from 'pages/Shop/Home/ShopHome/components/ToWeapp';
import { getFromSourceParam } from 'biz-micro-services-ui/project/pria/utils/util';
import { parseCustomLink } from 'biz-micro-services-ui/project/middlePlatform/function/util';
const defaultListData = {
  list: [],
  isLoading: false,
  hasPullToRefresh: true,
  pageNum: 1,
  pages: 1
};

class ShopHomeMod {
  // 保存滑动的位置
  @observable scrollTop = 0;

  // 首页固定资源（banner、应用位、资讯位）是否正在加载
  @observable staticRefreshing = false;

  // 首页楼层资源（资讯位以下的动态排序数组）是否正在加载
  @observable floorRefreshing = false;

  // 悬浮窗数据
  @observable floatWindow = {};

  // banner位
  @observable bannerList = [];

  // banner是否加载完成
  @observable isBannerLoaded = false;

  // banner上面固定按钮列表
  @observable buttonList = [];

  // 首页背景图
  @observable backgroundImgWrap = {};

  // 首页背景图是否配置
  @observable hasBackgroundImg = false;

  // 应用位
  @observable applicationList = [];
  @observable moduleDisplayMethod = 0;

  // banner是否加载完成
  @observable isAppLoaded = false;

  // 访客记录
  @observable visitorRecordsList = [];

  // 资讯位
  @observable news = [];

  // 资讯是否加载完成
  @observable isNewsLoaded = false;

  // 楼层数组（首页资讯以下都是楼层）
  @observable floorList = [];

  // 楼层是否加载完成
  @observable isFloorLoaded = false;

  // 最新楼层数组（临时存储楼层数据）
  @observable tempFloorList = [];

  @observable couponList = [
    {
      couponRenewModal: false
    }
  ];

  // // 活动的tab
  // @observable activeTab = 0;

  // // 有无新消息
  // @observable hasMsg = true;

  // // tab列表
  // @observable tabList = [];

  // // 显示tab弹出框
  // @observable isShowBox = false;

  // // 最新资讯
  // @observable lateNews = [];

  // // 首页-商品列表
  // @observable productList = [];

  // // 新品上市-产品分页
  // @observable newProduct = defaultListData;

  // // 推荐位列表
  // @observable homeRecommend = JSON.parse(utils.getLocalCache(Config.localStorageKeys.shop_homeRecommend) || '[]');

  // // 与banner对应的颜色列表
  // @observable colorList = [];

  // // 专题页数据
  // @observable spcData = [];

  // 秒杀 - 即将开始数据
  @observable seckillWill = {};

  // 权益共享卡绑定返回
  @observable supplementMsg = '';

  @observable supplementData = false;

  @observable showSupplementModal = false; // 权益共享卡弹窗

  // 用户的专题页信息
  @observable activeActivityInfo = {};

  // 用户拥有的活动列表
  @observable activeActivityList = [];

  // 用户拥有的资格购活动
  @observable qualificationList = [];

  // banner背景图的色值
  @observable averageMap = new Map();

  @observable isDeep = true;

  // // 我的应用列表
  // @observable myApplist = [];

  // // 更多应用列表
  // @observable moreApplist = [];

  // 是否展示移动端新人下载套餐广告
  @observable isShowPoster = true;

  // 移动端新人下载套餐广告内容
  @observable posterContent = {};

  // 生日弹窗
  @observable birthdayInfo = {};

  // 生日弹窗集合
  @observable birthdayArr = [];

  // 弹框index
  @observable modalIndex = 0;

  // 未登陆的情况下，是否存在下载app的权限点
  @observable hasPermissions = false;

  isLoading = false; // 接口是否在请求，防止快速点击重复跳转

  // 红包雨数据
  @observable activityBaseListLength = 0;

  // 红包雨弹窗数据总数
  @observable detailLength = 0;

  // detail调用次数
  @observable isStart = 0;

  // detail调用次数
  @observable isCount = 0;

  // detail调用次数
  @observable activityStartList = [];

  // 红包雨弹窗数据
  @observable activityCountList = [];

  // 红包雨弹窗数据
  @observable hasMoreItemInfos = false;

  @observable needTimer = false;

  // 注册/升级提示弹窗
  @observable showModal = false;

  @observable upgrate = true;

  @observable member_userInfo = {};

  // 累计制/送券弹窗
  @observable AccoumnlateStatusV2 = false;

  @observable tipContent = {};

  @observable homeCarouselIndex = 1;

  @observable showWeappModal = false;

  // 打开小程序弹窗
  @observable liveRoomId = '';

  // 直播间ID
  @observable liveCoverUrl = '';

  // 直播封面
  @observable showWeappModalAdd = false;

  @observable repeatPromptList = [];

  // 打开小程序添加企微好友弹窗
  @observable weappChatAddId = ''; // 企微好友ID

  @observable commenderJumpType = 1; // 链商跳转类型 1: 跳转链商带token  2: 跳转链商推客  3: 跳转链商达人
  @observable showRecommenderWeapp = false; // 打开链商小程序
  // 打开小程序
  @observable showWeappModalMore = false;
  @observable target = '';
  @observable targetRoute = '';

  @observable linkStoreInfo = null;
  @observable showApply = false;
  @observable storeInfo = null;

  @observable curType = ''; // 当前链接类型
  @observable pathContent = ''; // type 23 路径参数

  // Tab导航相关
  @observable tabBarList = []; // Tab列表
  @observable initialPage = 0; // 当前选中的Tab索引
  // 用户手动选择的 Tab 索引（H5 刷新时优先恢复，-1 表示从未手动选过）
  userSelectedPage = -1;
  @observable tabFloorList = []; // Tab对应的楼层数据
  @observable tempTabFloorList = []; // 临时存储Tab楼层数据

  // Tab数据缓存，key为mallType，value为对应的楼层数据
  @observable tabDataCache = {};
  // Tab Banner缓存，key为mallType，value为对应的banner数据
  @observable tabBannerCache = {};
  // Tab应用位缓存，key为mallType，value为对应的应用位数据
  @observable tabModuleCache = {};

  // Tab专属的Banner和应用位数据（当前显示的）
  @observable tabBannerList = []; // Tab的Banner数据
  @observable tabModuleList = []; // Tab的应用位数据
  @observable totalDiscountAmount = null; // 累计节省金额
  @observable qualificationListActivityId = null; // 资格购产品列表推荐位的活动 ID
  // 资格购列表用户选中的标签 ID（H5 单页应用从详情返回时恢复用），null 表示"全部"
  qualificationSelectedTagId = null;
  // 资格购列表标签栏横向滚动位置（H5 从详情返回时恢复用）
  qualificationTagScrollX = 0;

  THIS = '';

  // 个体户认证状态 1 已认证 0 未认证
  // @observable certificationStatus = 0;

  constructor() {
    const bannerList = JSON.parse(
      Util.getLocalCache(Config.localStorageKeys.shop_homeBanner) || '[]'
    );
    const applicationList = JSON.parse(
      Util.getLocalCache(Config.localStorageKeys.shop_homeApplication) || '[]'
    );
    const news = JSON.parse(Util.getLocalCache(Config.localStorageKeys.shop_homeNews) || '[]');
    if (bannerList.length && bannerList[0].imgInfo) {
      this.bannerList = bannerList;
      this.isBannerLoaded = true;
    }
    if (applicationList.length) {
      this.applicationList = applicationList.slice(0, 10);
      this.isAppLoaded = true;
    }
    if (news.length) {
      this.news = news;
      this.isNewsLoaded = true;
    }
  }

  @computed
  get qualificationProductShowBv() {
    const userInfo = Stores.AppMod.userInfo || {};
    // cardType 卡类型（-1优惠顾客，0普，1银，2金，3钻）
    const cardType = userInfo.cardType;
    return Stores.AppMod.token && cardType >= 0;
  }

  /**
   * 修改参数逻辑
   */
  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  /**
   *
   * @param {Array} list - 某种楼层类型列表
   * @param {Number} renderType - 楼层类型：1-推荐位、2-三位图、3-图文推荐、4-分类推荐、5-广告图、6-产品楼层、7-标题位、8-产品推荐位、50-轮播图、88-热卖宫格
   */
  @action
  pushFloorData(list, renderType) {
    if (renderType == 88) {
      console.log('🚀 ~ ShopHomeMod ~ pushFloorData ~ list:', list);
      // this.tempFloorList = this.tempFloorList.concat(
      //   {list, renderType}
      // );
      // return
    }
    if (Array.isArray(list)) {
      this.tempFloorList = this.tempFloorList.concat(list.map((item) => ({ ...item, renderType })));
    }
  }

  getCouponData = flow(function* () {
    try {
      const { data } = yield Serv.getCouponData();
      return data;
    } catch (error) {}
  });

  /**
   * 获取秒杀-即将开始的数据
   */
  getSeckillWill = flow(function* (type) {
    try {
      const { data } = yield Serv.getSeckillWill({ type });
      if (Array.isArray(data)) {
        let seckillWill = toJS(this.seckillWill);
        seckillWill[type] = data;
        this.seckillWill = seckillWill;
      }
    } catch (error) {}
  });

  /**
   * 获取绑定权益共享卡信息
   * */
  getEquityCard = flow(function* (param) {
    try {
      const { data, resultCode, resultMsg } = yield Serv.getEquityCard(param);
      if (resultCode == 0 && data) {
        this.supplementData = data || false;
      } else {
        this.supplementMsg = resultMsg || t('邀请无效');
      }
      this.showSupplementModal = true;
    } catch (error) {}
  });

  /**
   * 刷新首页数据
   */
  refreshData = flow(function* () {
    this.staticRefreshing = true;
    this.floorRefreshing = true;
    this.tempFloorList = [];
    let fixedList = [
      this.getBanner(),
      this.getBackground(),
      this.getButtonList(),
      this.getApplication(),
      this.getNews(),
      this.getFloatWindow()
    ];
    if (Util.getLocalCache('onlineAddress') !== '1') {
      fixedList.unshift(this.getStoreInfo());
    }
    // 这里返回一个Promise，是为了抛出，是否首页全部数据加载完成
    return new Promise((resolve, reject) => {
      // 固定位置，直接请求数据
      Promise.all(fixedList).then(() => {
        runInAction(() => {
          this.staticRefreshing = false;
        });
        if (!this.floorRefreshing) resolve('succeed');
      });

      // 非固定位置，使用通用方法加载所有栏位数据
      this.loadAllCellData({
        includeTabBar: true,
        handleMethod: this.pushFloorData.bind(this)
      }).then(() => {
        // 楼层排序
        let list = toJS(this.tempFloorList);
        list.sort((pre, next) => pre.sort - next.sort);
        runInAction(() => {
          this.floorList = list;
          this.floorRefreshing = false;
          this.isFloorLoaded = true;
        });
        if (!this.staticRefreshing) resolve('succeed');
      });
    });
  });

  /**
   * 获取悬浮窗数据
   */
  getFloatWindow = flow(function* () {
    try {
      const { data } = yield Serv.getFloatWindow();
      if (data.imgUrl) {
        let newData = cloneDeep(data);
        newData.imgData = JSON.parse(newData.imgUrl);
        this.floatWindow = newData || {};
      } else {
        // 没有悬浮窗的时候要重新刷新
        this.floatWindow = data || {};
      }
    } catch (err) {
      this.floatWindow = {};
    }
  });

  getStoreInfo = flow(function* () {
    try {
      // const status = yield Stores.AppMod.queryCertificationStatus();
      const { data } = yield Serv.getStoreInfo();
      if (data) {
        // this.certificationStatus = status;
        this.storeInfo = data || {};
      }
    } catch (err) {
      this.storeInfo = null;
      console.log('getStoreInfo err', err);
    }
  });

  /**
   * 获取banner位置数据
   */
  getBanner = flow(function* () {
    try {
      const { data } = yield Serv.getBanner();
      if (Array.isArray(data)) {
        this.bannerList = data;
        Util.setLocalCache(Config.localStorageKeys.shop_homeBanner, JSON.stringify(data));
      }
      this.isBannerLoaded = true;
    } catch (err) {
      this.isBannerLoaded = true;
    }
  });

  /**
   * 获取首页背景图
   */
  getBackground = flow(function* () {
    try {
      const { data } = yield Serv.getBackground();
      if (data && Array.isArray(data)) {
        const resData = data[0] || {};
        const appImgUrl = resData.appImgUrl || '';
        const appImgUrl2 = resData.appImgUrl2 || '';
        if (appImgUrl && appImgUrl2) {
          let bgImgWrap = {};
          bgImgWrap.appImgUrl = appImgUrl;
          bgImgWrap.appImgUrl2 = appImgUrl2;
          this.hasBackgroundImg = true;
          this.backgroundImgWrap = bgImgWrap;
        }
      } else {
        this.backgroundImgWrap = {};
        this.hasBackgroundImg = false;
      }
    } catch (err) {
      this.backgroundImgWrap = {};
      this.hasBackgroundImg = false;
    }
  });

  /**
   * 获取固定按钮位置
   */
  getButtonList = flow(function* () {
    try {
      const { data } = yield Serv.getButtonList();
      this.buttonList = data || [];
    } catch (err) {}
  });

  /**
   * 获取应用位数据
   */
  getApplication = flow(function* () {
    try {
      const { data } = yield Serv.getApplication();
      if (Array.isArray(data)) {
        this.applicationList = data.slice(0, 10);
        // displayMethod 展示方式  0->banner下面  1->随机配置(根据sort)
        const displayMethod = data[0] && data[0].displayMethod;
        this.moduleDisplayMethod = 0;
        if (displayMethod == 1) {
          this.moduleDisplayMethod = 1;
          const sort = data[0] && data[0].applicationSort;
          const applicationData = [{ data: this.applicationList, sort }];
          this.pushFloorData(applicationData, 1028);
        }
        // Util.setLocalCache(Config.localStorageKeys.shop_homeApplication, JSON.stringify(data));
      } else {
        this.applicationList = [];
      }
      this.isAppLoaded = true;
    } catch (err) {
      this.applicationList = [];
      this.isAppLoaded = true;
    }
  });

  /**
   * 获取店铺类型列表
   */
  getStoreTypeList = flow(function* (isPartner = false) {
    try {
      const { healthConsultantNum } = Stores.AppMod.userInfo || {};
      const params = {
        configure: 1,
        healthCode: healthConsultantNum,
        jointCreationTag: isPartner ? 1 : 0
      };
      let { data } = yield Serv.getStoreTypeList(params);
      if (Array.isArray(data)) {
        data = data.map((item) => {
          // storeName 0 对外名称 1 开店政策
          const { storeName, typeName, externalName } = item;
          return {
            ...item,
            typeName: storeName === 0 ? externalName : typeName
          };
        });
        return data;
      }
      return [];
    } catch (error) {
      console.log('dshjkhdakj===>', error);
      return [];
    }
  });

  /**
   * 获取区域配置情况
   *
   * @memberof PersonalMod
   */
  getRegionConfiguration = flow(function* (typeId) {
    try {
      const { data } = yield Serv.getRegionConfiguration({ typeId });
      if (data) {
        return data;
      }
      return false;
    } catch (error) {
      return false;
    }
  });

  /**
   * 获取资讯位数据
   */
  getNews = flow(function* () {
    try {
      const { data } = yield Serv.getNews();
      if (Array.isArray(data)) {
        this.news = data;
        Util.setLocalCache(Config.localStorageKeys.shop_homeNews, JSON.stringify(data));
      }
      this.isNewsLoaded = true;
    } catch (err) {
      this.isAppLoaded = true;
    }
  });

  verifyMemberCardValid = flow(function* () {
    try {
      const { data, resultCode } = yield Serv.verifyMemberCardValid();
      if (data) {
        return data;
      }
      return false;
    } catch (error) {}
  });

  verifyMemberCardValidV2 = flow(function* (ignoreError) {
    try {
      const { data, resultCode, resultMsg } = yield Serv.verifyMemberCardValidV2({
        ignoreErr: !!ignoreError,
        jointCreationTag: ignoreError ? 1 : 0
      });
      return { data, resultMsg };
    } catch (error) {}
  });

  // 检查联创代理信息
  checkLianChuangProxy = flow(function* (ignoreError) {
    try {
      const { data, resultMsg } = yield Serv.checkLianChuangProxy(ignoreError);
      return { data, resultMsg };
    } catch (error) {
      return { data: {}, resultMsg: '' };
      console.log('检查联创代理信息失败', error);
    }
  });

  /**
   * 获取推荐位数据
   */
  getRecommender = flow(function* () {
    try {
      const { data } = yield Serv.getRecommender();
      const list = [];
      for (const item of data) {
        if (item.combinationType === 0) {
          // 对称宫格 一组2个 最多8组
          for (let i = 0; i < 16; i += 2) {
            const arr = item.datas.slice(i, i + 2);
            arr.length &&
              list.push({
                ...item,
                datas: arr
              });
          }
        } else if (item.combinationType === 1) {
          // 横向宫格 一组1个 最多8组
          for (let i = 0; i < 8; i += 1) {
            const arr = item.datas.slice(i, i + 1);
            arr.length &&
              list.push({
                ...item,
                datas: arr
              });
          }
        } else if (item.combinationType === 2) {
          // 横向宫格 一组3个 最多3组
          for (let i = 0; i < 9; i += 3) {
            const arr = item.datas.slice(i, i + 3);
            arr.length &&
              list.push({
                ...item,
                datas: arr
              });
          }
        } else if (item.combinationType === 3) {
          // 横向宫格 一组3个 最多2组
          for (let i = 0; i < 6; i += 3) {
            const arr = item.datas.slice(i, i + 3);
            // console.log('arr>>>>', i, arr);
            arr.length &&
              list.push({
                ...item,
                datas: arr
              });
          }
        }
      }
      this.pushFloorData(list, 1);
    } catch (err) {}
  });

  /**
   * 获取推荐位数据
   */
  getCarousel = flow(function* () {
    try {
      const { data } = yield Serv.getCarousel();
      this.pushFloorData(data, 50);
    } catch (err) {}
  });

  /**
   * 获取健康时刻表数据
   */
  getHealthTimeLine = flow(function* () {
    try {
      const { data } = yield Serv.getHealthTimeLine();
      let newData = data
        ? data.length > 0
          ? data.map((item) => {
              return {
                item,
                sort: item.sortMain
              };
            })
          : []
        : [];
      this.pushFloorData(newData, 23);
    } catch (err) {}
  });

  /**
   * 获取三位图数据
   */
  getThreeImgs = flow(function* () {
    try {
      const { data } = yield Serv.getThreeImgs();
      this.pushFloorData(data, 2);
    } catch (err) {}
  });

  /**
   * 获取图文推荐数据
   */
  getImgText = flow(function* () {
    try {
      const { data } = yield Serv.getImgText();
      this.pushFloorData(data, 3);
    } catch (err) {}
  });

  /**
   * 获取分类推荐数据
   */
  getClassify = flow(function* () {
    try {
      const { data } = yield Serv.getClassify();
      this.pushFloorData(data, 4);
    } catch (err) {}
  });

  /**
   * 获取热卖宫格数据
   * @memberof ShopHomeMod
   */
  getHotRecommend = flow(function* () {
    try {
      const { data } = yield Serv.getHotRecommend();
      this.pushFloorData(data, 88);
    } catch (err) {
      console.log(err);
    }
  });

  /**
   * 获取组合推荐位
   * @memberof CombinedRecommend
   */
  getCombinedRecommend = flow(function* () {
    try {
      const { data } = yield Serv.getCombinedRecommend();
      this.pushFloorData(data, 117);
    } catch (err) {
      console.log(err);
    }
  });

  /**
   * 获取广告图数据
   */
  getAdvPicture = flow(function* () {
    try {
      const { data } = yield Serv.getAdvPicture();
      this.pushFloorData(data, 5);
    } catch (err) {}
  });

  /**
   * 获取产品楼层数据
   */
  getProductFloor = flow(function* () {
    try {
      const { data } = yield Serv.getProductFloor();
      this.pushFloorData(data, 6);
    } catch (err) {}
  });

  /**
   * 获取标题数据
   */
  getTitleGuide = flow(function* () {
    try {
      const { data } = yield Serv.getTitleGuide();
      this.pushFloorData(data, 7);
    } catch (err) {}
  });

  /**
   * 获取产品推荐数据
   */
  getRecommendProduct = flow(function* () {
    try {
      const { data } = yield Serv.getRecommendProduct();
      this.pushFloorData(data, 8);
    } catch (err) {}
  });

  // 获取专题页活动信息
  getrRcommendPageInfo = flow(function* (specialId) {
    try {
      const { data, resultCode, resultMsg } = yield Serv.getrRcommendPageInfo({
        recommendId: specialId
      });
      if (resultCode == 0 && data) {
        this.activeActivityInfo = data || {};
      } else {
        this.activeActivityInfo = {};
      }
    } catch (err) {
      console.log('err', err);
      this.activeActivityInfo = {};
    }
  });

  // 获取服务器时间
  getrServerTime = flow(function* (specialId) {
    try {
      const { data, resultCode, resultMsg } = yield Serv.getrServerTime();
      if (resultCode == 0 && data) {
        this.serverTime = data.datetime;
      } else {
        this.serverTime = new Date();
      }
    } catch (err) {
      console.log('err', err);
      this.serverTime = new Date();
    }
  });

  // 获取活动列表
  getQueryActiveActivityList = flow(function* () {
    try {
      const { data, resultCode, resultMsg } = yield Serv.getQueryActiveActivityList({
        type: 9,
        status: 2
      });
      if (resultCode == 0 && data) {
        this.activeActivityList = data || [];
      } else {
        this.activeActivityList = [];
      }
    } catch (err) {
      console.log('err', err);
      this.activeActivityList = [];
    }
  });

  // 获取资格购列表
  getQualificationList = flow(function* () {
    try {
      const { data, resultCode, resultMsg } = yield Serv.getQualificationList({
        isPurchasingAgent: 0
      });
      if (resultCode == 0 && data) {
        this.qualificationList = data || [];
      } else {
        this.qualificationList = [];
      }
    } catch (err) {
      console.log('err', err);
      this.qualificationList = [];
    }
  });

  /**
   * 查询资格购活动
   * 判断用户是否有当前资格购活动的资格
   */
  getActivityInfo = flow(function* (activityId) {
    try {
      const { data, resultCode, resultMsg } = yield Serv.getActivityInfo(activityId);
      if (resultCode == 0 && data) {
        return data;
      }
      return false;
    } catch (err) {
      console.log(err);
      return false;
    }
  });

  /**
   * 获取用户支持的配货比例
   */
  getUserdistriBution = flow(function* () {
    try {
      let { data } = yield Serv.getUserdistriBution({ orderType: 1 });
      // let distributionRatioList = [];
      let obj = {};
      let defaultItem = {
        label: t('未选择'),
        orderMinAmount: 0,
        value: '-1'
      };

      let handleDistriBution = (data) => {
        let distMap = [];
        if (data && data.length > 0) {
          // 按从小到大排序
          // for (let i = 0; i < data.length - 1; i++) {
          //   for (let j = 0; j < data.length - 1 - i; j++) {
          //     if (+data[j].orderProperty > +data[j + 1].orderProperty) {
          //       [data[j], data[j + 1]] = [data[j + 1], data[j]];
          //     }
          //   }
          // }

          distMap = data.map((item) => {
            const { orderProperty, orderPropertyName, orderMinAmount, orderMinBv } = item;

            return {
              value: orderProperty,
              label: `${orderPropertyName} ${t('配货')}`,
              orderMinAmount,
              orderMinBv
            };
          });
        }
        return distMap;
      };

      obj['1'] = [defaultItem, ...handleDistriBution(data)];
      const { data: data2 } = yield Serv.getUserdistriBution({ orderType: 2 });
      obj['2'] = [defaultItem, ...handleDistriBution(data2)];

      return obj;
    } catch (error) {}
  });

  checkFirstCateGory = flow(function* (id) {
    if (!id) return;
    try {
      const { data } = yield Serv.checkFirstCateGory(id);

      return data;
    } catch (err) {
      return false;
    }
  });

  /**
   * 查询是否可开实体卡或虚拟卡
   */
  queryCanApplyType = flow(function* (cardTypeId, exObj) {
    try {
      const { healthConsultantNum, phone } = Stores.AppMod.userInfo;
      const { sourceTag = '' } = exObj || {};
      const params = {
        channel: 0,
        healthConsultantCardCode: healthConsultantNum || '8888888888'
      };
      const { data } = yield Serv.queryCanApplyType(params);
      // 0 - 只能开虚拟卡，1 - 只能开实体卡，2 - 可开虚拟卡或实体卡
      Toast.hide();
      if (data == null) return;
      window.app.routerGoTo({
        pathname: '/register/MemCardBasticMsg',
        clear: true,
        state: {
          clear: true,
          phone,
          cardTypeId,
          sourceTag
        }
      });
      // if (data != 0) {
      //   // ignoreFictitious: 是否不可开虚拟卡
      //   window.app.routerGoTo({
      //     pathname: '/register/physicalCard',
      //     state: {
      //       ignoreFictitious: data == 1,
      //       applyType: '3',
      //       phone,
      //     },
      //   });
      // } else {
      //   window.app.routerGoTo({
      //     pathname: '/register/memCardMsg',
      //     state: {
      //       applyType: '3',
      //       phone,
      //     },
      //   });
      // }
    } catch (error) {
      Toast.hide();
    }
  });

  /**
   * 查询图片的平均色
   */
  searchAverageColor = flow(function* (imgUrl) {
    if (!imgUrl) return;
    const color = this.averageMap.get(imgUrl);

    if (color) {
      // this.averageColor = color;
      const rgbArr = Util.doHexToRGB(color);

      const r = rgbArr[0];
      const g = rgbArr[1];
      const b = rgbArr[2];

      this.isDeep = r * 0.299 + g * 0.578 + b * 0.114 < 192;
      return;
    }

    try {
      const result = yield Serv.getImgAverageColor(imgUrl);
      if (result) {
        // 对平均色，做处理：加深饱和度，降低亮度
        let newColor = result.RGB || StyleConfig.colorPrimary;
        // if (newColor) {
        //   newColor = Util.doHandleColor(result.RGB);
        // }
        // newColor = newColor || StyleConfig.colorPrimary;

        // this.averageColor = newColor;
        this.averageMap.set(imgUrl, newColor);

        const rgbArr = Util.doHexToRGB(newColor);

        const r = rgbArr[0];
        const g = rgbArr[1];
        const b = rgbArr[2];

        this.isDeep = r * 0.299 + g * 0.578 + b * 0.114 < 192;
      }
    } catch (err) {
      console.log('MallHomeMobx - searchAverageColor err', err);
    }
  });

  /**
   * 上报信息
   */
  accumulateUserInfo = flow(function* (params) {
    try {
      const { resultCode, data } = yield Serv.accumulateUserInfo(params);
      if (+resultCode === 0) {
        return data;
      }
    } catch (error) {}
  });

  // /**
  //  * 首页banner轮播
  //  */
  // @computed
  // get carousel() {
  //   for (let i = 0; i < this.homeRecommend.length; i++) {
  //     if (`${this.homeRecommend[i].recommandType}` == '0') {
  //       return this.homeRecommend[i];
  //     }
  //   }
  //   return { object: [] };
  // }

  // /**
  //  * 首页数据列表（除掉第一项banner）
  //  */
  // @computed
  // get recommandList() {
  //   let list = [...toJS(this.homeRecommend)];
  //   for (let i = 0; i < list.length; i++) {
  //     if (`${list[i].recommandType}` == '0') {
  //       list.splice(i, 1);
  //       break;
  //     }
  //   }
  //   return list;
  // }

  // /**
  //  * 首页tab列表数据
  //  */
  // @computed
  // get tabData() {
  //   return [this.homeRecommend, ...this.spcData];
  // }

  /**
   * 移动端新人下载套餐广告
   */

  queryNewcomer = flow(function* () {
    try {
      const { resultCode, data } = yield Serv.queryNewcomer();

      if (resultCode === '0' && data && data.imgUrl) {
        this.posterContent = {
          ...data,
          ...data.imgInfo
        };
      } else {
        fetchData({ popupPosition: popupPositionMap.HOME });
      }
    } catch (error) {}
  });

  fetchBirthdayInfo = flow(function* () {
    try {
      const { data } = yield Serv.fetchBirthdayInfo();
      // 取第一个弹框
      let initObj = {};
      if (Array.isArray(data)) {
        initObj = data[0];
        this.birthdayArr = data;
      }
      if (initObj) {
        this.birthdayInfo = initObj;
      }
    } catch (error) {}
  });

  // 跳转到课程列表
  jumpCreamCourseList = (data) => {
    let oneTopic;
    let secTopic;
    if (data.parentId === 0) {
      oneTopic = data.id;
      secTopic = undefined;
    } else {
      oneTopic = data.parentId;
      secTopic = data.id;
    }
    window.app.routerGoTo({
      pathname: '/learn/thematic/class',
      state: {
        routers: [
          {
            key: data.id,
            title: data.name,
            index: 0,
            oneTopic, // 一级专题
            secTopic // 二级专题
          }
        ],
        index: 0,
        creamCourseName: data.name,
        isShowTabBar: false
      }
    });
  };

  // 跳转到销售专区
  jumpToSaleZone = () => {
    const { saleZone = '', memberStatus } = Stores.AppMod.userInfo || {};
    if (memberStatus !== 0) {
      window.showConfirmModal({
        title: '提示',
        content:
          '亲爱的会员，您的专属会员资格待激活哦！完成订单激活后，即可解锁销售专区的购物通道，尊享会员专享福利～',
        leftTxt: '关闭',
        hideRightText: true,
        leftStyle: {
          backgroundColor: '#f01b3f',
          color: '#fff'
        }
      });
      return;
    }
    // 销售专区
    if (!saleZone) {
      Toast.info('暂无购买权限');
      return;
    }
    window.app.routerGoTo({
      pathname: '/member/quickBuy',
      state: {
        globalSaleMode: 2
      }
    });
  };

  /**
   * 首页各栏位的点击跳转事件
   * @param {链接类型} type
   * 1自定义链接 2产品详情 3产品列表-类目id 4文章详情 5搜索结果-搜索keyword 6促销活动 7促销主题页 8专题页 9资格购 10内部链接跳转 81销售专区 82 全部产品分类  83 复消自选
   * @param {链接内容} content 类目id/产品id/文章id/l链接
   * @param {活动类型} extend 链接类型为促销活动时，保存的是 活动类型
   */
  doLinkJump = flow(function* (
    {
      type,
      content,
      extend,
      memberCard,
      memberName,
      memberId,
      birthday,
      birthDayTag,
      ment,
      isPopRecommend = false, // 是否弹窗推荐
      promptImgUrl = '', // 弹窗推荐图片
      qualifyPage,
      globalSaleMode,
      fromActiveSource,
      description,
      isXkcActivity,
      xkcActivityCoupon,
      indAdvPicture
    } = this.posterContent
  ) {
    console.log('asdkjaksjdooo1', type);
    // 如果type没有值，不做处理
    if (!type || type == 0) {
      console.log('ShopHomeMod - doLinkJump no type', type);
      return;
    }
    if (type == 21) {
      // window.location.href = 'https://mp.weixin.qq.com/s/gxUQ4rMn1_jvkgVuwLy-CQ';
      Toast.info('请打开有享云商APP关注公众号');
      return;
    }
    if (type == 24) {
      if (!Stores.AppMod.token) {
        Util.setLocalCache(Config.localStorageKeys.loginGoback, true); // 登录后是否返回指定页面的标识
        // offlineActivityId 区分活动中心
        Util.setLocalCache(
          Config.localStorageKeys.registerRoute,
          `/promote/offlineActivity/activityDetail?offlineActivityId=${content}`
        ); // 登录后是否返回指定页面的标识
        window.app.routerGoTo('/login');
        return;
      }
      Stores.AppMod.meetValidate(content).then((data) => {
        if (data) {
          window.app.routerGoTo(`/promote/offlineActivity/activityDetail?id=${content}`);
        } else {
          Toast.info('暂无资格参与');
        }
      });
    }

    if (type == 73) {
      this.showApply = true;
      return;
    }

    // 如果content没有值，不做处理
    if ((!content || content == '') && type != 18 && type != 81 && type != 82 && type != 83) {
      console.log('ShopHomeMod - doLinkJump no content');
      return;
    }
    const strLinkBase = 'https://h5.yofogo.com/specialPage/';
    console.log('asdkjaksjdooo2', type);

    switch (type) {
      case 1: // 自定义链接
        if (content === 'https://h5.yofogo.com/20240530') {
          this.THIS.setState({
            showCarnivalModal: true,
            showCarnivalWeapplUrl: 'pages/ThematicScreen/Carnival/20240530/Carnival/index',
            showCarnivalWeapplShareCard:
              'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/image/app/year-meeting/20240530/share_card.png'
          });
          return;
        }
        if (content === 'https://h5.yofogo.com/20240416') {
          this.THIS.setState({
            showCarnivalModal: true,
            showCarnivalWeapplUrl: 'pages/ThematicScreen/Carnival/20240416/index',
            showCarnivalWeapplShareCard:
              'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/yundian/assets/img/rankActivity/share.png'
          });
          return;
        }
        if (content == 'https://h5.yofogo.com/commonweal') {
          // 三生公益活动
          window.app.routerGoTo({
            pathname: '/shop/home/publicWelfareView'
          });
          return;
        }
        if (content === 'https://h5.yofogo.com/taiYearCard') {
          // 肽素乳畅享卡 有肽素乳畅享卡的权限并且下过订单才能进入肽素乳畅享卡页面
          if (!isHasRouteAuth(routeAuthCodeMap.PERSONAL_BATCH_ORDER)) {
            Toast.info('抱歉，您的肽素乳畅享卡权益不可用，详情可咨询客服');
            return;
          }
          Stores.AppMod.getShowBatchOrder().then((data) => {
            if (data) {
              window.app.routerGoTo({
                pathname: '/personal/PeptideMilkAnnualPass'
              });
            } else {
              Toast.info('未查询到您购买过肽素乳畅享卡');
            }
          });
          return;
        }
        if (content && content.indexOf('ldMini') > -1) {
          // 跳转乐道小程序// 获取=之后的数据
          this.syncLd().then((res) => {
            if (res) {
              try {
                const idVal =
                  res === true
                    ? (Stores.AppMod.userInfo && Stores.AppMod.userInfo.cardCode) || ''
                    : res;
                const v = `${content.split('=')[1]}?orderid=${idVal}`;
                window.location.href = v;
              } catch (error) {}
            }
          });
          return;
        }
        if (content && content.indexOf('recommender') > -1) {
          // 跳转推客小程序 http://recommender.com?type=tuike
          let jumpType = 1;
          if (content.indexOf('tuike') > -1) {
            jumpType = 2;
          }
          if (content.indexOf('daren') > -1) {
            jumpType = 3;
          }
          // 链商小程序
          if (Util.isWeiXin()) {
            this.changeState({
              commenderJumpType: jumpType,
              showRecommenderWeapp: true,
              usernameStr: ghObj[`${Util.getQueryParams(content).name}`] || ''
            });
            return;
          } else {
            Toast.info('请登录有享云商APP或者有享小店再体验链商小程序！', 2);
          }
          return;
        }
        if (content.indexOf(strLinkBase) > -1) {
          this.setState({
            showCarnivalModal: true,
            showCarnivalWeapplUrl: `pages/ThematicScreen/Special/index?id=${content.replace(strLinkBase, '')}`,
            showCarnivalWeapplShareCard:
              'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/image/app/year-meeting/20241030/share_card.png'
          });
          return;
        }
        if (
          content.indexOf('https://wd.yofopay.com') > -1 ||
          content.indexOf('https://wd.yofogo.com') > -1
        ) {
          this.jumpToFengniao(content);
          return;
        }
        if (/^(mpsxy):\/\//.test(content)) {
          const linkData = parseCustomLink(content, 'mpsxy');
          const { success, path: routePath } = linkData || {};
          if (success && routePath) {
            window.showMiniProgramModal({
              path: routePath,
              imgUrl:
                'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/images/common/sxy_mini_program_image.png',
              username: 'gh_b5d04d764715'
            });
          }
          return;
        }
        if (/^(app|h5|pc|mp):\/\//.test(content)) {
          // 内部自定义链接
          const linkData = parseCustomLink(content, 'h5');
          console.log('linkData>>>>', linkData);
          const { success, path: routePath } = linkData || {};
          if (success && routePath) {
            window.app.routerGoTo(routePath);
          }
          return;
        }
        window.location.href = content;
        break;
      case 2: // 产品详情
        // window.app.routerGoTo(`/shop/productDetail/${content}`);
        let search2 = getFromSourceParam(fromActiveSource);
        if (ment) {
          search2 = {
            ment,
            ...search2
          };
        }
        search2 = Util.encodeQuery(search2);
        window.app.routerGoTo({
          pathname: `/shop/productDetail/${content}`,
          search: search2
        });
        break;
      case 3: // 产品列表-类目id
        // window.app.routerGoTo({
        //   pathname: '/shop/productList',
        //   state: {
        //     frontDirIdList: [content],
        //   },
        // });
        if (fromActiveSource) {
          // 宫主会逻辑  根据id列表跳转到产品列表
          let contentInfo = '';
          let contentId = '';
          let searchParams = {};
          try {
            contentInfo = JSON.parse(content);
          } catch (e) {
            console.log('data.content err', e);
          }
          if (contentInfo.content) {
            const { content: id, ...otherParams } = contentInfo;
            contentId = id;
            searchParams = otherParams || {};
          } else {
            contentId = content;
          }
          const search = Util.encodeQuery({ fromActiveSource });
          this.checkFirstCateGory(contentId)
            .then((data) => {
              if (data.displayType == 1) {
                window.app.routerGoTo({
                  pathname: `/shop/home/importantSeriesView/${data.id}`,
                  state: {
                    dirId: data.id,
                    title: data.name
                  },
                  search
                });
              } else {
                // extension 层级类目
                if (data.extension === '1') {
                  window.app.routerGoTo({
                    pathname: `/shop/home/productClassfiy/${contentId}`,
                    state: {
                      searchParams,
                      dirId: data.id,
                      title: data.name
                    },
                    search
                  });
                } else {
                  window.app.routerGoTo({
                    pathname: '/shop/productList',
                    state: {
                      frontDirIdList: [contentId],
                      searchParams
                    },
                    search
                  });
                }
              }
            })
            .catch((err) => {
              window.app.routerGoTo({
                pathname: '/shop/productList',
                state: {
                  frontDirIdList: [contentId],
                  searchParams,
                  sourceTag: '首页'
                },
                search
              });
            });
          break;
        } else {
          let search3 = { fromActiveSource };
          if (ment) {
            search3 = {
              ment,
              ...search3
            };
          }
          search3 = Util.encodeQuery(search3);
          console.log('search3', search3);
          window.app.routerGoTo({
            pathname: '/shop/productList',
            state: {
              frontDirIdList: [content]
            },
            search: search3
          });
          break;
        }
      case 4: // 文章详情
        window.app.routerGoTo(`/shop/home/news/${content}`);
        break;
      case 5: // 搜索结果
        // window.app.routerGoTo(`/shop/productList?keyword=${content}`);
        let search5 = {
          keyword: content
        };
        if (ment) {
          search5.ment = ment;
        }
        window.app.routerGoTo({
          pathname: '/shop/productList',
          search: Util.encodeQuery(search5)
        });
        break;
      case 6: // 促销活动
        // window.app.routerGoTo(`/shop/home/activity/normal/${content}`);
        let search6 = Util.encodeQuery({});
        if (ment) {
          search6 = Util.encodeQuery({
            activityLink: ment
          });
        }
        window.app.routerGoTo({
          pathname: `/shop/home/activity/normal/${content}`,
          search: search6
        });
        break;
      case 7: // 促销主题页
        // window.app.routerGoTo(`/shop/home/activity/theme/${content}`);
        let search7 = Util.encodeQuery({});
        if (ment) {
          search7 = Util.encodeQuery({
            activityLink: ment
          });
        }
        window.app.routerGoTo({
          pathname: `/shop/home/activity/theme/${content}`,
          search: search7
        });
        break;
      case 8: // 专题页
        const state = {
          birthday: birthDayTag === 1
        };
        localStorage.setItem('birthDayTagFlag', birthDayTag);
        let url =
          extend == 1
            ? `/shop/home/specialProduct/${content}`
            : extend == 4
              ? `/shop/home/special/${content}`
              : `/shop/home/specialClassify/${content}`;

        // 三生豆商品列表
        if (extend == 8) {
          url = '/PunchClock/RecommendBeanList';
        }

        // 九月开卡活动
        if (content === '1284572010394067054') {
          url = '/shop/home/landingPage';
        }

        // 国际版的 优享会拦截跳转并提示
        if (Stores.AppMod.isInternationalized && description && description.includes('#优享会#')) {
          Toast.info('抱歉，当前地区暂时不参与活动');
          return;
        }

        // 1产品列表专题页、4自定义专题页、5产品分类专题页
        // window.app.routerGoTo({pathname: url, state});
        let search8 = { fromActiveSource };
        if (ment) {
          search8 = {
            ment,
            ...search8
          };
        }

        search8 = Util.encodeQuery(search8);
        if (extend == 8) {
          search8 = Util.encodeQuery({
            recommendId: content
          });
        }
        window.app.routerGoTo({
          pathname: url,
          state,
          search: search8
        });
        break;
      case 9: // 资格购
        // 跳转到所有资格购活动列表
        try {
          if (content == 'all') {
            // window.app.routerGoTo(`/shop/qualificationPage?showFlag=${true}`);
            let search9 = Util.encodeQuery({ showFlag: true });
            if (ment) {
              search9 = Util.encodeQuery({
                ment,
                showFlag: true
              });
            }
            window.app.routerGoTo({
              pathname: '/shop/qualificationPage',
              search: search9
            });
            return;
          }
          // Toast.loading();
          // 资格购跳转
          let qualificationList = yield this.getQualificationList();

          // Toast.hide();
          // if (!birthday) {
          //   const qualification = qualificationList.find(
          //     item => item.id == content,
          //   );
          //   if (!qualification) {
          //     Toast.info('您没有当前活动资格');
          //     return;
          //   }
          // }
          this.jumpToLimitBuy({
            content,
            showFlag: true,
            memberCard,
            memberName,
            memberId,
            birthday,
            qualificationList: this.qualificationList,
            ment,
            qualifyPage: qualifyPage,
            globalSaleMode,
            isXkcActivity,
            xkcActivityCoupon
          });
        } catch (err) {
          console.log('🥳-=====>', err);
        }
        break;
      case 10: // 内部链接跳转
        // 开卡升级指定卡类型
        const { route: routesValue, id: idValue, appLink } = JSON.parse(content || null) || {};
        const { saleZone = '', memberStatus } = Stores.AppMod.userInfo || {};
        if (appLink == 'HealthPage' || appLink == 'AiDigitalManHome') {
          Toast.info('体验该功能请下载有享云商APP');
          return;
        }
        if (routesValue == 'healthHome' || routesValue == 'Health') {
          Modal.alert('', '体验该功能请下载有享云商APP', [
            { text: '取消' },
            {
              text: '确定',
              onPress: () =>
                window.open('https://a.app.qq.com/o/simple.jsp?pkgname=com.yofoto.yofoys')
            }
          ]);
          return;
        }
        if (routesValue == 'OpenCard') {
          // 配置跳转到升级开卡选购礼包界面
          this.applyNextUpgrade(idValue);
          return;
        }
        if (!Stores.AppMod.token) {
          window.app.routerGoTo('/login');
          return;
        }
        if (routesValue == 'SaleZone') {
          this.jumpToSaleZone();
          return;
        }
        const contentObj = JSON.parse(content);
        let route = contentObj.route || contentObj.h5Link;
        const id = contentObj.id || contentObj.detailId;

        if (
          route === 'Livebroadcast' ||
          route === 'liveRoom' ||
          route === 'CstoreLivebroadcast' ||
          route === 'CstoreLiveRoom'
        ) {
          let roomId = '';
          if (Util.isValidJSON(content)) {
            let roomContent = JSON.parse(content);
            roomId = roomContent.id || roomContent.detailId;
          }
          let isCstore = route == 'CstoreLivebroadcast' || route == 'CstoreLiveRoom'; // 是否云小店直播相关
          // 微信环境打开小程序弹窗

          console.log(roomId, 'roomid');
          if (Util.isWeiXin()) {
            let imgUrl = '';
            if (isPopRecommend && promptImgUrl) {
              const imgJson = (promptImgUrl && JSON.parse(promptImgUrl)) || {};
              imgUrl = imgJson.imgUrl || '';
            }
            console.log('微信环境打开小程序弹窗');
            // 微信环境打开小程序弹窗
            this.getLiveList()
              .then((res) => {
                Toast.hide();
                console.log('resres直播', res);
                if (res && res.length > 0) {
                  let result = res.find((item) => item.roomid == roomId);
                  if (result) {
                    // 取列表图片
                    this.changeState({
                      liveRoomId: roomId || '',
                      showWeappModal: true,
                      liveCoverUrl: result.share_img || '',
                      wechatAppid: isCstore ? 'gh_825754bbda7f' : 'gh_62517e9b6920'
                    });
                  } else {
                    // 默认图片
                    this.changeState({
                      liveRoomId: roomId || '',
                      showWeappModal: true,
                      liveCoverUrl: imgUrl,
                      wechatAppid: isCstore ? 'gh_825754bbda7f' : 'gh_62517e9b6920'
                    });
                  }
                }
              })
              .catch((err) => {
                // 默认图片
                this.changeState({
                  liveRoomId: roomId || '',
                  showWeappModal: true,
                  liveCoverUrl: imgUrl,
                  wechatAppid: isCstore ? 'gh_825754bbda7f' : 'gh_62517e9b6920'
                });
              });
          } else {
            Toast.info(`${t('请登录有享云商APP观看直播')}！`, 2);
          }
          return;
        }

        // 跳转三生素材库页面
        if (route === 'SanshengMaterial') {
          if (Util.isWeiXin()) {
            this.changeState({
              showWeappModalMore: true,
              target: 'sanshengMaterial',
              targetRoute: id || ''
            });
          } else {
            Toast.info('请搜索“三生素材库”小程序查看素材', 2);
          }
          return;
        }
        if (id && route) {
          if (route == '/learn/thematic/class') {
            this.getThematicDetail({ id }).then((data) => {
              if (data) {
                if (data.typeLevel === 1) {
                  // 一级专题跳转到详情页
                  this.jumpCreamCourseList(data);
                } else if (data.typeLevel === 2) {
                  // //parentId大于0就跳课程列表，parentId等于0就跳专题列表
                  // if (Number(data.parentId) > 0) {
                  //   this.jumpCreamCourseList(data);
                  // } else if (Number(data.parentId) == 0) {
                  const params = { title: data.name };

                  if (data.parentId === 0) {
                    params.oneTopic = data.id;
                    params.secTopic = null;
                  } else {
                    params.oneTopic = data.parentId;
                    params.secTopic = data.id;
                  }
                  window.app.routerGoTo({
                    pathname: `/learn/thematic/detail/${data.id}`,
                    state: params
                  });
                  // }
                }
              }

              // }
            });
            return;
          }

          // 培训中心-工具流 抖音页面
          if (route == '/learn/tools/ToolVideo') {
            this.props.AppMod.changeState('fromHome', true);
            window.app.routerGoTo({
              pathname: '/learn/tools/ToolsView',
              state: {
                thematicId: id,
                initialSlide: 0
              }
            });
            return;
          }

          // 培训中心-工具流专题
          if (route == '/learn/tools/ToolsView') {
            Stores.AppMod.changeState('fromHome', true);
            // window.app.routerGoTo(`${route}?thematicId=${id}`);
            window.app.routerGoTo({
              pathname: '/learn/tools/ToolsView',
              state: {
                initialSlide: 1,
                thematicId: id
              }
            });
            return;
          }

          // 权益中心-指定权益
          if (route == '/promote/equity/customize') {
            this.getEquityInfo({
              rightsId: id
            }).then((data) => {
              if (data) {
                const { displayMode, got, posterImg } = data || {};
                if (displayMode == 1) {
                  if (got == 1) {
                    if (posterImg) {
                      window.app.routerGoTo({
                        pathname: '/promote/equity/customize',
                        state: data
                      });
                    } else {
                      window.app.routerGoTo({
                        pathname: `/promote/equity`,
                        state: {
                          rightsInfo: data || {}
                        }
                      });
                    }
                  }
                } else {
                  window.app.routerGoTo({
                    pathname: `/promote/equityImageText`,
                    state: {
                      rightsInfo: data || {}
                    }
                  });
                }
                this.recordRead({
                  rightsId: id
                });
              }
            });
            return;
          }

          window.app.routerGoTo(`${route}?id=${id}`);
          return;
        }

        if (route) {
          // if (route === '/learn/finding') {
          // 处理返回目标页
          Stores.AppMod.changeState('fromHome', true);
          // }
          // 培训中心工具流-首页
          if (route == '/learn/tools/ToolsView/ToolsThematic') {
            Stores.AppMod.changeState('fromHome', true);
            // window.app.routerGoTo(`${route}?thematicId=${id}`);
            window.app.routerGoTo({
              pathname: '/learn/tools/ToolsView',
              state: {
                initialSlide: 1,
                isHome: true
              }
            });
            return;
          }
          if (route == 'BirthdayCard') {
            window.app.routerGoTo({
              pathname: '/shop/home/birthdayCardView'
            });
            return;
          }
          window.app.routerGoTo(route);
        }
        break;
      case 12:
        // 跳转到排行榜活动
        window.app.routerGoTo({
          pathname: '/shop/home/sortActivityView',
          search: Util.encodeQuery({
            keyword: content
          })
        });
        break;
      case 18:
        // 1逛素材2享咨询3云逛逛4官方咨询
        const obj = content && typeof content === 'string' && JSON.parse(content);

        if (name == '官方资讯' || obj.articleCategoryNo == 4) {
          window.app.routerGoTo({
            pathname: `/shop/home/officialInformation`,
            state: {
              articleTypeId: obj.articleTypeId
            }
          });
          return;
        }

        if (!indAdvPicture) {
          // 广告图
          indAdvPicture = '';
        }

        if (
          obj.articleCategoryNo == 1 ||
          name == '逛素材' ||
          obj[`articleCategoryNo${indAdvPicture}`] == 1
        ) {
          window.app.routerGoTo({
            pathname: `/shop/guang`,
            state: {
              articleTypeId: obj.articleTypeId || obj[`articleTypeId${indAdvPicture}`],
              titleName: '逛素材'
            }
          });
          return;
        }

        if (
          obj.articleCategoryNo == 3 ||
          name == '云逛逛' ||
          obj[`articleCategoryNo${indAdvPicture}`] == 3
        ) {
          window.app.routerGoTo({
            pathname: `/shop/guang`,
            state: {
              articleTypeId: obj.articleTypeId || obj[`articleTypeId${indAdvPicture}`],
              titleName: '云逛逛'
            }
          });
          return;
        }

        if (Array.isArray(obj.articleTypeId)) {
          window.app.routerGoTo({
            pathname: '/learn/articleList',
            state: {
              categoryId: obj.articleTypeId.pop(),
              categoryName: ''
            }
          });
          return;
        }

        obj.articleTypeId &&
          this.news &&
          this.news.length > 0 &&
          window.app.routerGoTo({
            pathname: '/shop/home/news',
            state: {
              articleTypeId: obj.articleTypeId
            }
          });
        break;
      case 23:
        if (Util.isWeiXin()) {
          this.changeState({
            showWeappModal: true,
            curType: 23,
            pathContent: content || '',
            wechatAppid: 'gh_62517e9b6920'
          });
        } else {
          Toast.info('请登录有享云商APP查看！', 2);
        }
        break;
      case 32:
        isHasRouteAuth(routeAuthCodeMap.PERSONAL_DISCOUNT_COUPON) &&
          content &&
          window.app.routerGoTo('/member/wallet/coupon');
        break;
      case 38:
        if (content === 'recommender') {
          // 链商小程序
          if (Util.isWeiXin()) {
            this.changeState({ showRecommenderWeapp: true });
            return;
          } else {
            Toast.info('请登录有享云商APP或者有享小店再体验链商小程序！', 2);
          }
        } else if (content === 'SanshengMaterial') {
          // 三生素材库
          if (Util.isWeiXin()) {
            showToWeapp({
              icon: 'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/images/common/sanshengMaterial_icon.png',
              path: '/pages/index/index',
              username: 'gh_ca6449f8285c'
            });
            return;
          } else {
            Toast.info('请登录有享云商APP或者三生素材库再体验小程序！', 2);
          }
        } else if (content === 'SanshengBusinessMaterial') {
          // 三生事业素材库
          if (Util.isWeiXin()) {
            showToWeapp({
              icon: 'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/images/common/sanshengBusinessMaterial_icon.png',
              path: '/pages/index/index',
              username: 'gh_d431d44775b7'
            });
            return;
          } else {
            Toast.info('请登录有享云商APP或者三生素材库再体验小程序！', 2);
          }
        } else if (content === 'SbnMaterial') {
          // 视百年素材库
          if (Util.isWeiXin()) {
            showToWeapp({
              icon: 'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/images/common/sbnMaterial_icon.png',
              path: '/pages/index/index',
              username: 'gh_676dfde0879c'
            });
            return;
          } else {
            Toast.info('请登录有享云商APP或者视百年素材库再体验小程序！', 2);
          }
        }
        break;
      case 66:
        // 有享直播间
        if (Util.isWeiXin()) {
          this.THIS.setState({
            liveRoomId: content.id || '',
            showWeappModal: true,
            liveCoverUrl: content.imgUrl || '',
            wechatAppid: 'gh_825754bbda7f'
          });
        } else {
          Toast.info(`${t('请登录有享云商APP观看直播')}！`, 2);
        }

        break;
      case 70:
        // AI展业星球
        Toast.info('体验该功能请下载有享云商APP');

        break;
      case 81: // 销售专区
        this.jumpToSaleZone();
        break;
      case 82: // 全部产品分类
        // 未登录时跳转至登录页
        if (!Stores.AppMod.token) {
          window.app.routerGoTo('/login');
          return;
        }
        // 各个功能点击次数统计埋点
        this.tranckFunctionClick('分类', 'CLASSIFICATION_ICON');
        window.app.routerGoTo({
          pathname: '/shop/QuickProductList',
          state: {
            sourceTag: '首页'
          }
        });
        break;
      // 复消自选
      case 83: {
        if (!Stores.AppMod.token) {
          window.app.routerGoTo('/login');
          return;
        }
        const distributionRatioList = Stores.AppMod.userInfo.distributionRatioList || [];
        const defaultDisRadioList = (distributionRatioList[2] || []).sort(
          (a, b) => a.value - b.value
        );
        window.app.routerGoTo({
          pathname: '/member/quickBuy',
          state: {
            defaultOrderType: 2,
            defaultDisRadio: (defaultDisRadioList[0] && defaultDisRadioList[0].value) || ''
          }
        });
        break;
      }
      case 112:
        // 三生素材库
        if (Util.isWeiXin()) {
          this.THIS.setState({
            showWeappModalMore: true,
            target: 'sanshengMaterial',
            targetRoute: `/pages/materialDetail/index?value=${content.title || ''}&nid=${content.nid}`
          });
        } else {
          Toast.info('请搜索“三生素材库”小程序查看素材', 2);
        }
        break;
      case 66:
        // 有享直播间
        if (Util.isWeiXin()) {
          this.THIS.setState({
            liveRoomId: content.id || '',
            showWeappModal: true,
            liveCoverUrl: content.imgUrl || '',
            wechatAppid: 'gh_825754bbda7f'
          });
        } else {
          Toast.info(`${t('请登录有享云商APP观看直播')}！`, 2);
        }

        break;
      case 70:
        // AI展业星球
        Toast.info('体验该功能请下载有享云商APP');

        break;
      case 112:
        // 三生素材库
        if (Util.isWeiXin()) {
          this.THIS.setState({
            showWeappModalMore: true,
            target: 'sanshengMaterial',
            targetRoute: `/pages/materialDetail/index?value=${content.title || ''}&nid=${content.nid}`
          });
        } else {
          Toast.info('请搜索“三生素材库”小程序查看素材', 2);
        }
        break;
      default:
        break;
    }
  });

  // 各个功能点击次数统计埋点
  tranckFunctionClick = (name, authCode = '') => {
    const { userInfo } = Stores.AppMod;
    const { cardCode } = userInfo || {};
    window.sensors.track('functionClickCount', {
      authCode, // 权限点名称
      name, // 功能名字
      cardCode,
      belongSystem: userInfo && userInfo.belongSystem, // 站点
      position: '首页', // 位置
      source: 'H5' // 来源
    });
  };

  // 邀请注册自主升级
  applyNextUpgrade = flow(function* (cardTypeId = '', exObj) {
    const { userInfo, token } = Stores.AppMod;
    const { cardCode, userType, cardType, isVip, systemType, lifecycleTag, lifecycleMaxCardType } =
      userInfo || {};
    const { inletTitle = '', sourceTag = '' } = exObj || {};
    if (!token) {
      // Util.setLocalCache(Config.localStorageKeys.loginGoback, true) // 登录后是否返回原来页面的标识
      // const route = window.location.href.split('#') || [];
      // Util.setLocalCache(Config.localStorageKeys.registerRoute, route[1] || '') // 登录后是否返回原来页面的标识
      window.app.routerGoTo('/login');
    }
    if (userType == 1) {
      this.queryCanApplyType(cardTypeId, { sourceTag });
      return;
    }
    try {
      // 以前最高级别为 cardType 3
      // 古语最高级别为钻3 cardType 6
      // 并且要是VIP
      if (
        ((cardType == 3 && systemType == '0') ||
          (systemType == '1' && !!lifecycleTag && cardType === lifecycleMaxCardType)) &&
        isVip != 0
      ) {
        Toast.info(`${t('该会员已经是最高级别')}，${t('无法继续升级')}`);
        return;
      }
      Toast.loading();
      const params = {
        bizUpgradeCardReqDto: {
          cardCode,
          channel: 1
        }
      };
      const { data } = yield Serv.queryCardType(params);
      Util.setLocalCache(Config.localStorageKeys.member_cardTypeData, data);
      Toast.hide();
      if (cardTypeId == -1 || !cardTypeId) {
        // 不限制
        window.app.routerGoTo({
          pathname: '/register/memGiftbag',
          clear: false,
          defaultCheck: true,
          state: {
            applyType: '4', // '4'会员升级
            HealthyCardCode: cardCode,
            inletTitle,
            sourceTag
          }
        });
        // window.location.reload()
      } else {
        let item = data.find((item) => item.id == cardTypeId);
        if (!item || !item.id) {
          Toast.fail(`${t('无购买权限')}，${t('请联系健康顾问')}`, 2, () => {
            window.app.routerRedirect({ pathname: '/shop/home' });
          });
          return;
        }
        window.app.routerGoTo({
          pathname: '/register/memGiftbag',
          clear: false,
          defaultCheck: true,
          state: {
            applyType: '4', // '4'会员升级
            card: {
              bv: item.bv,
              bvMode: item.bvMode,
              id: item.id,
              maxAmount: item.maxAmount,
              minAmount: item.minAmount,
              type: item.type
            },
            HealthyCardCode: cardCode,
            cardTypeId,
            inletTitle,
            sourceTag
          }
        });
        // window.location.reload()
      }
    } catch (err) {}
  });

  /**
   * 跳转资格够
   *
   */
  jumpToLimitBuy = ({
    content = '',
    showFlag = false,
    memberCard = '',
    memberName = '',
    memberId = '',
    birthday = '',
    qualificationList,
    ment = '',
    inletTitle = '',
    source = '',
    qualifyPage,
    sourceTag = '',
    isReplace = false,
    isFromTopic = false,
    globalSaleMode,
    isXkcActivity = false,
    xkcActivityCoupon,
    remark = '',
    routerRedirect = false,
    isWelfare = false, // 三生公益活动页资格购标识 单品、批量购物
    callBack
  }) => {
    if (!content) return;
    if (this.isLoading) return;
    this.isLoading = true;
    this.getActivityInfo(content)
      .then((data) => {
        if (data) {
          const baseReqDto = data.baseReqDto || {};
          const { orderType, allocateCargoScale = [], shoppingPatterns, leftClassify } = baseReqDto;

          if (!birthday && !remark && !isWelfare) {
            const flag = this.qualificationList.find((item) => {
              return item.id == content;
            });
            if (!flag && data.activityStatus != 2) {
              console.log(data.activityStatus);
              switch (data.activityStatus) {
                case 1:
                  Toast.info(`${t('当前活动未开始')}，${t('请耐心等待')}`);
                  break;
                // case 2:
                //   Toast.info('您没有当前活动资格');
                //   break;
                default:
                  Toast.info(t('活动已过期'));
                  break;
              }

              return;
            }
          }

          // shoppingPatterns 0单品 1-批量(跳转到资格购购物车)
          if (!shoppingPatterns) {
            // 三生公益活动页 单品跳转资格购活动页
            isWelfare && callBack && callBack();
            const params = {
              id: content
            };

            if (memberId) {
              params.memberId = memberId;
            }

            if (memberCard) {
              params.memberCard = memberCard;
            }

            if (memberName) {
              params.memberName = memberName;
            }

            if (birthday) {
              params.birthday = birthday;
            }
            params.showFlag = showFlag;

            if (ment) {
              params.activityLink = ment;
            }
            params.remark = remark;

            const paramsData = {
              pathname: `/shop/qualification`,
              search: Util.encodeQuery(params),
              state: {
                inletTitle: source === 'MRYP' ? source : inletTitle,
                sourceTag: sourceTag
              }
            };
            if (routerRedirect) {
              window.app.routerRedirect(paramsData);
            } else {
              window.app.routerGoTo(paramsData);
            }
            return;
          }

          if (shoppingPatterns) {
            let orderTypeList = [];
            const distributionRatioList = {};
            let allocateCargoScaleList = allocateCargoScale || [];
            let orderType = baseReqDto.orderType;
            if (leftClassify) {
              const leftClassifyLimitBuyList = qualificationList.filter((item) => {
                if (item.leftClassify === 2) {
                  return content === item.id;
                }
                return item.shoppingPatterns === 1 && item.leftClassify === 1;
              });
              if (leftClassifyLimitBuyList.length == 0) {
                leftClassifyLimitBuyList.push(baseReqDto);
              }
              leftClassifyLimitBuyList.forEach((item) => {
                if (leftClassify !== 2) {
                  const itemAllocateCargoScaleList = Array.isArray(item.allocateCargoScale)
                    ? item.allocateCargoScale
                    : (item.allocateCargoScale && item.allocateCargoScale.split(',')) || [];
                  allocateCargoScaleList = _.union(
                    itemAllocateCargoScaleList,
                    allocateCargoScaleList
                  );
                }
                const itemOrderTypeList = item.orderType ? [item.orderType] : [1, 2]; // 0-代表零售和月复消均支持
                orderTypeList = _.union(itemOrderTypeList, orderTypeList);
              });

              if (orderTypeList.length > 1) {
                orderType = 0;
              } else {
                orderType = orderTypeList[0];
              }
            } else {
              orderTypeList = orderType ? [orderType] : [1, 2];
            }
            allocateCargoScaleList = allocateCargoScaleList.sort((a, b) => a - b);

            orderTypeList.forEach((item) => {
              const list = allocateCargoScaleList.map((scale) => ({
                label: `1:${scale} ${t('配货')}`,
                orderMinAmount: 0,
                orderMinBv: null,
                value: `${scale}`
              }));
              distributionRatioList[item] = list;
            });
            console.log(
              '🥸===>',
              allocateCargoScaleList,
              orderType,
              distributionRatioList,
              !!leftClassify,
              orderTypeList
            );
            const params = {
              id: content,
              showFlag,
              isBirthday: birthday ? 1 : 0,
              activityLink: ment,
              orderTypeList: JSON.stringify(orderTypeList)
            };
            if (memberId) {
              params.memberId = memberId;
            }

            if (memberCard) {
              params.memberCard = memberCard;
            }

            if (memberName) {
              params.memberName = memberName;
            }
            remark && (params.remark = remark);
            const jumpParam = {
              pathname: `/member/quickBuyForCoupon`,
              state: {
                allocateCargoScale: allocateCargoScaleList,
                orderType,
                distributionRatioList,
                showLeftTree: !!leftClassify, // 是否展示侧边分类 1-展示 0-不展示
                inletTitle: source === 'MRYP' ? source : inletTitle,
                source,
                tabIndex: qualifyPage === 2 ? 1 : '',
                leftClassify: leftClassify,
                sourceTag,
                isFromTopic,
                globalSaleMode: baseReqDto && baseReqDto.saleMode === 2 ? 2 : globalSaleMode,
                dgCardCode: memberCard,
                // 是否是配置了享考察的活动
                isXkcActivity,
                xkcActivityCoupon
              },
              search: Util.encodeQuery(params)
            };
            if (isReplace) {
              window.app.routerRedirect(jumpParam);
            } else {
              window.app.routerGoTo(jumpParam);
            }
          }
        } else {
          Toast.info(t('您没有当前活动资格'));
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  };

  /**
   * 检测是否当天生日，能否参加生日活动，不传参数 默认检测自己
   */
  checkBirthday = flow(function* (params) {
    const array = [];
    Object.keys(params).forEach((key) => {
      array.push(`${key}=${params[key]}`);
    });
    let p = array.length ? `?${array.join('&')}` : '';
    const url = `user/info/checkBirthday`;
    try {
      const result = yield Serv.checkBirthday(url);
      return result;
    } catch (e) {
      console.log('err:', e);
    }
  });

  getThematicDetail = flow(function* (params) {
    try {
      const { resultCode, data } = yield Serv.getThematicDetail(params);

      if (resultCode === '0') {
        return data;
      }
      return null;
    } catch (err) {}
  });

  // 获取直播列表
  getLiveList = flow(function* () {
    try {
      const data = yield Serv.getLiveList();
      console.log(data, 'dddd');
      return data;
    } catch (err) {
      console.log('errrr', err);
      Toast.hide();
      if (err && err.code == 1) {
        return err.object;
      }
    }
  });

  // getShareId
  getShareId = flow(function* (id, type) {
    if (!Stores.AppMod.token) {
      return 'no login';
    }
    try {
      const paramsData = {
        shareContentId: id,
        type
      };

      const { data } = yield Serv.getShareId(paramsData);
      // this.shareId = data.shareId
      return data.shareId;
    } catch (error) {
      console.log(error);
    }
  });

  // injectVistor
  injectVistor = flow(function* ({ shareContentId, shareId, type }) {
    try {
      const { data } = yield Serv.injectVistor({
        source: 1,
        type,
        shareContentId,
        sourceId: shareId
      });
      console.log(data, 'dddd');
      return data || {};
    } catch (err) {
      console.log('errrr', err);
    }
  });

  // getRecordList
  getRecordList = flow(function* ({ shareContentId, type }) {
    if (!Stores.AppMod.token) {
      // window.app.routerGoTo('/login');
      return;
    }
    try {
      const { data } = yield Serv.getRecordList({
        type,
        shareContentId
      });
      const { list } = data;
      this.visitorRecordsList = list;
      return data || {};
    } catch (err) {
      console.log('errrr', err);
    }
  });

  // 获取续费优惠券列表
  getDelayList = flow(function* () {
    try {
      const data = yield Serv.getDelayList();
      // console.log('datadatadatadata',data)
      this.couponList = data.data.map((item, index) => {
        console.log(item, index);
        if (index == 0) {
          item.couponRenewModal = true;
        } else {
          item.couponRenewModal = false;
        }
        return item;
      });
      console.log(this.couponList, '=======dddd======');
      // return data
    } catch (err) {
      console.log('errrr', err);
      Toast.hide();
      if (err && err.code == 1) {
        return err.object;
      }
    }
  });

  getDelayCoupon = flow(function* (params, callback) {
    try {
      const data = yield Serv.getDelayCoupon(params);
      if (data) {
        callback && callback();
      }

      // return data
    } catch (err) {
      Toast.hide();
      if (err && err.code == 1) {
        return err.object;
      }
    }
  });

  /**
   * 三生体系未登录的情况下，是否显示下载app读公司的权限点
   * 获取权限点
   */
  getGongSiEnterList = flow(function* () {
    try {
      const { data } = yield Serv.getGongSiEnterList();
      if (data) {
        const list = [];
        for (let key in data) {
          const datas = data[key];
          datas.forEach((item) => {
            list.push(item.routeKey);
          });
        }

        const downloadKey = list.find((routerKey) => routerKey === routeAuthCodeMap.DOWNLOAD_BOOT);

        this.hasPermissions = !Stores.AppMod.token && !!downloadKey;
      }
    } catch (err) {}
  });

  /**
   * 新体系未登录的情况下，可以直接调取获取权限点
   * 获取权限点
   */
  getEnterList = flow(function* () {
    try {
      const { data } = yield Serv.getEnterList();

      const list = [];
      if (data) {
        // 1-展业 2-我的 3-有享助手

        data.forEach((item) => {
          // enterType: 1-路由，2-标签
          list.push(item.routeKey);
        });

        const downloadKey = list.find((routerKey) => routerKey === routeAuthCodeMap.DOWNLOAD_BOOT);

        this.hasPermissions = !Stores.AppMod.token && !!downloadKey;
      }
    } catch (err) {
      console.log('dhjsakhda===>err', err);
    }
  });

  /**
   * 生命周期 - 头等舱弹窗
   * source 来源 home 首页 personal 我的页面
   * firstClassRemindTag 头等舱提醒标识，1：需要提醒
   * remindTag 生命周期累计制弹窗标识 1: 需要提醒
   * 只有来自首页才展示后管配置的 获得头等舱资格 弹窗
   * 弹窗优先级 卡密弹窗>头等舱弹窗>累积制弹窗(升级)>广告弹窗>首页后管配置弹窗 ??> 权益共享卡
   */
  getUpgradeRecent = flow(function* (source) {
    try {
      const { data } = yield Serv.getUpgradeRecent();
      if (data.firstClassRemindTag == 1 && source === 'home') {
        fetchData(
          { popupPosition: popupPositionMap.FIRST_CLASS },
          () => {
            // 有累计制 先弹累计制弹窗
            if (data.remindTag == 1) {
              this.changeState({
                AccoumnlateStatusV2: true
              });
            } else {
              if (!Stores.AppMod.homePopupShow) {
                this.isShowPoster && this.queryNewcomer();
                !this.isShowPoster && fetchData({ popupPosition: popupPositionMap.HOME });
                Stores.AppMod.changeState('homePopupShow', true);
              }
            }
          },
          () => {
            // 有累计制 先弹累计制弹窗
            if (data.remindTag == 1) {
              this.changeState({
                AccoumnlateStatusV2: true
              });
            } else {
              if (!Stores.AppMod.homePopupShow) {
                this.isShowPoster && this.queryNewcomer();
                !this.isShowPoster && fetchData({ popupPosition: popupPositionMap.HOME });
                Stores.AppMod.changeState('homePopupShow', true);
              }
            }
          }
        );
        return true;
      }
      if (data.remindTag == 1) {
        this.AccoumnlateStatusV2 = true;
      }
      this.tipContent = data;
      return this.AccoumnlateStatusV2;
    } catch (error) {
      return false;
    }
  });

  // 保存弹窗显示记录
  savePopupRecord = flow(function* (id) {
    const params = {
      popupId: id
    };
    try {
      const { data } = yield Serv.savePopupRecord(params);
      return data;
    } catch (error) {}
  });

  // 获取移动端活动广告弹窗
  getActiveAdList = flow(function* (params) {
    this.activityBaseListLength = 0;
    this.detailLength = 0;
    this.activityStartList = [];
    this.activityCountList = [];
    this.isStart = 0;
    this.isCount = 0;
    try {
      const { data } = yield Serv.getActiveAdList(params);
      const itemInfos =
        data.filter((item) => item.popupRemindType == 4 || item.popupRemindType == 5) || [];
      this.activityBaseListLength = itemInfos.length;
      if (itemInfos.length > 0) {
        itemInfos.map((el) => {
          if (el.popupRemindType == 4 || el.popupRemindType == 5) {
            this.getDrawSetting(el.drawActivityId, el);
          }
          // if (el.popupRemindType == 4) {
          //   isStart += 1
          // }else if (el.popupRemindType == 5) {
          //   isCount += 2
          // }
        });
        if (itemInfos.length > 1) {
          this.hasMoreItemInfos = true;
        }
      }
      return data || [];
    } catch (error) {
      console.log(error, 'error');
    }
  });

  // 抽奖活动详情
  getDrawSetting = flow(function* (activityId, el) {
    // this.detailLength += 1
    try {
      const { resultCode, data } = yield Serv.getDrawSetting({
        activityId
      });
      if (resultCode === '0') {
        const { activityBaseReqDto, prizeRespDtos } = data;
        if (activityBaseReqDto) {
          this.detailLength += 1;
          let startTime = new Date(activityBaseReqDto.effectiveTime).getTime();
          let endTime = new Date(activityBaseReqDto.invalidTime).getTime();
          let nowTime = new Date().getTime();
          console.log('结果====>', el, activityBaseReqDto, startTime, nowTime, el.popupRemindType);
          if (el.popupRemindType == 4) {
            this.isStart += 1;
            if (el.frequencyType == 6 && startTime > nowTime) {
              // 全局红包雨倒计时存储
              Util.setLocalCache('redEnvelopeStartTimeOne', startTime);
            }
            const imgJson = (el.promptImgUrl && JSON.parse(el.promptImgUrl)) || {};
            const imgUrl = imgJson.imgUrl || '';
            // 抽奖活动开始
            console.log(
              '这儿呢444==',
              activityBaseReqDto,
              nowTime >= startTime,
              endTime > nowTime,
              activityBaseReqDto.startSecond
            );
            if (
              // (nowTime >= startTime) && (endTime > nowTime) &&
              activityBaseReqDto.startSecond < 0 &&
              activityBaseReqDto.activityStatus == 2
            ) {
              let realData = activityBaseReqDto;
              realData.saveId = el.id;
              realData.popupRemindType = el.popupRemindType;
              realData.promptImgUrl = imgUrl;
              this.activityStartList = [realData];
              // this.hasMoreItemInfos = true
            } else {
              this.hasMoreItemInfos = false;
              if (Util.getLocalCache('redEnvelopeStartTimeOne') > nowTime) {
                this.needTimer = true;
              }
            }
          }
          if (el.popupRemindType == 5) {
            this.isCount += 2;
            const imgJson = (el.promptImgUrl && JSON.parse(el.promptImgUrl)) || {};
            const imgUrl = imgJson.imgUrl || '';
            // 抽奖活动倒计时
            console.log(
              '这儿呢555==',
              el,
              activityBaseReqDto,
              startTime > nowTime,
              activityBaseReqDto.startSecond > 0
            );
            if (startTime > nowTime && activityBaseReqDto.startSecond > 0) {
              // 全局红包雨倒计时存储
              Util.setLocalCache('redEnvelopeStartTime', startTime);
              let realData = activityBaseReqDto;
              realData.popupRemindType = el.popupRemindType;
              realData.saveId = el.id;
              realData.promptImgUrl = imgUrl;
              this.activityCountList = [realData];
              // this.hasMoreItemInfos = true
            } else {
              this.hasMoreItemInfos = false;
            }
          }
          console.log();
          if (
            this.isStart == this.activityBaseListLength ||
            this.isCount == this.activityBaseListLength * 2
          ) {
            this.hasMoreItemInfos = false;
          }
        }
        return activityBaseReqDto;
      }
    } catch (error) {}
  });

  // 查询是否真实开始下红包雨
  hongbaoyuStart = flow(function* (id) {
    try {
      const result = yield Serv.hongbaoyuStart({ activityId: id });

      return result;
    } catch (error) {}
  });

  // 点击红包雨
  drawStart = flow(function* (id) {
    try {
      const result = yield Serv.drawStart({ activityId: id });

      return result;
    } catch (error) {}
  });

  // 红包雨点击后的返回列表
  drawList = flow(function* (id) {
    try {
      const result = yield Serv.drawList({ drawActivityId: id, pageSize: 99 });

      return result.data;
    } catch (error) {}
  });

  // 获取权益 + 特权配置
  getRightsSetting = flow(function* (id) {
    if (!Stores.AppMod.token) return;
    try {
      const result = yield Serv.getRightsSetting();

      if (result.resultCode == '0') {
        return result.data || [];
      }
    } catch (error) {}
  });

  // 获取悬浮条数据
  queryRepeatPrompt = flow(function* () {
    try {
      const result = yield Serv.queryRepeatPrompt();
      if (result.resultCode == '0') {
        this.repeatPromptList = result.data || [];
      }
    } catch (error) {}
  });

  // 跳转到蜂鸟
  jumpToFengniao = flow(function* (content) {
    try {
      const { data, resultCode } = yield Serv.getFengniaoCode();
      if (resultCode == '0') {
        let path = '';
        const urlObj = new URL(content);
        if (content.includes('?path=')) {
          const arr = content.split('?path=');
          path = arr[1];
        }
        const url =
          urlObj.origin +
          urlObj.pathname +
          '?code=' +
          data.code +
          '&sign=' +
          data.sign +
          '&path=' +
          encodeURIComponent(path);
        window.location.href = url;
      }
    } catch (error) {}
  });

  // 同步乐道数据
  syncLd = flow(function* () {
    try {
      const result = yield Serv.syncLd();
      if (result.resultCode == '0') {
        return result.data;
      }
    } catch (error) {}
  });

  getLinkStoreInfo = flow(function* (userId) {
    try {
      const result = yield Serv.getLinkStoreInfo(userId);
      if (result.resultCode == '0') {
        this.linkStoreInfo = result.data;
      }
    } catch (error) {
      console.log('getLinkStoreInfo err', error);
    }
  });

  getEquityInfo = flow(function* (params) {
    try {
      const result = yield Serv.getEquityInfo(params);
      if (result.resultCode == '0' && result.data) {
        return result.data;
      }
    } catch (error) {
      console.log('getEquityInfo err', error);
    }
  });

  recordRead = flow(function* (params) {
    try {
      const { resultCode } = yield Serv.recordRead(params);
      if (resultCode === '0') {
        return true;
      }
    } catch (error) {
      console.log('recordRead error', error);
    }
  });

  /**
   * 根据卡类型获取默认选中的tab
   * 未登录和优惠顾客默认选中零售(4)，普卡及以上默认选中消费(5)
   */
  getDefaultTabIndexByCardType = (routes) => {
    // const userInfo = (Stores.AppMod && Stores.AppMod.userInfo) || {};
    // const cardType = userInfo.cardType;

    // 德道普卡及以上也默认零售，也就是所有场景都是默认选中零售，后期德道普卡及以上可能还是会调整回默认消费的，所以下面的代码先注释
    const retailIndex = routes.findIndex((tab) => tab.linkRecommandId === MallType.RETAIL);
    return retailIndex >= 0 ? retailIndex : 0;

    // 未登录或优惠顾客或合和，默认选中零售
    // if (
    //   cardType === undefined ||
    //   cardType === null ||
    //   cardType === CardType.DISCOUNT_CUSTOMER ||
    //   Stores.AppMod.isHEH
    // ) {
    //   const retailIndex = routes.findIndex((tab) => tab.linkRecommandId === MallType.RETAIL);
    //   return retailIndex >= 0 ? retailIndex : 0;
    // }

    // // 普卡及以上，默认选中消费
    // if (cardType >= CardType.NORMAL) {
    //   const consumeIndex = routes.findIndex((tab) => tab.linkRecommandId === MallType.CONSUME);
    //   return consumeIndex >= 0 ? consumeIndex : 0;
    // }

    // return 0;
  };

  /**
   * 处理栏位数据预处理
   * @param {*} resData - 原始响应数据
   * @param {number} renderType - 渲染类型
   */
  processCellData = flow(function* (resData, renderType) {
    // 推荐位：需要按 combinationType 拆分数据
    if (renderType === 1) {
      const list = [];
      for (const item of resData || []) {
        if (item.combinationType === 0) {
          // 对称宫格 一组2个 最多8组
          for (let i = 0; i < 16; i += 2) {
            const arr = item.datas.slice(i, i + 2);
            arr.length && list.push({ ...item, datas: arr });
          }
        } else if (item.combinationType === 1) {
          // 横向宫格 一组1个 最多8组
          for (let i = 0; i < 8; i += 1) {
            const arr = item.datas.slice(i, i + 1);
            arr.length && list.push({ ...item, datas: arr });
          }
        } else if (item.combinationType === 2) {
          // 横向宫格 一组3个 最多3组
          for (let i = 0; i < 9; i += 3) {
            const arr = item.datas.slice(i, i + 3);
            arr.length && list.push({ ...item, datas: arr });
          }
        } else if (item.combinationType === 3) {
          // 横向宫格 一组3个 最多2组
          for (let i = 0; i < 6; i += 3) {
            const arr = item.datas.slice(i, i + 3);
            arr.length && list.push({ ...item, datas: arr });
          }
        }
      }
      return list;
    }

    // 分类推荐：接口把 activityId/activityType/discountSalePrice 下发在商品关系外层，
    // itemStyle/hasActivity 下发在楼层 data 层；渲染层只消费 itemInfo，这里统一补齐，避免组件重复刷新时反复加工数据。
    if (renderType === 4) {
      return (resData || []).map((cell = {}) => {
        const { classifyItemRelationRespDtoList = [], itemStyle, hasActivity = 0 } = cell || {};
        const normalizedItemList = (classifyItemRelationRespDtoList || []).map((item = {}) => {
          const { itemInfo = {}, activityId = '', activityType = '', discountSalePrice } = item;
          return {
            ...item,
            itemInfo: {
              ...itemInfo,
              activityId,
              activityType,
              discountSalePrice:
                discountSalePrice !== undefined ? discountSalePrice : itemInfo.discountSalePrice,
              itemStyle: itemStyle !== undefined ? itemStyle : itemInfo.itemStyle,
              hasActivity
            }
          };
        });

        return {
          ...cell,
          classifyItemRelationRespDtoList: normalizedItemList
        };
      });
    }

    // 健康时刻表：需要转换 sort 字段
    if (renderType === 23) {
      return (resData || []).map((item) => ({
        item,
        sort: item.sortMain
      }));
    }

    // TabBar：需要特殊处理
    if (renderType === 24) {
      // 清空缓存，重新加载所有tab的数据
      runInAction(() => {
        this.tabDataCache = {};
        this.tabModuleCache = {};
        this.tabBannerCache = {};
      });
      if (resData && resData.length > 0) {
        // 根据卡类型获取默认选中的tab
        const routes = resData.map((tab, index) => ({
          index,
          linkRecommandId: tab.linkRecommandId
        }));
        const defaultIndex = this.getDefaultTabIndexByCardType(routes);

        // 优先恢复用户手动选择的 tab（H5 刷新时保持上次选中的 tab）
        // 若用户从未手动选过，或选的 index 超出当前 tab 数量，才用卡类型默认值
        const validUserSelected =
          this.userSelectedPage >= 0 && this.userSelectedPage < resData.length;
        this.initialPage = validUserSelected ? this.userSelectedPage : defaultIndex;
        this.tabBarList = resData;

        // 预加载所有tab数据
        yield this.preloadAllTabsData();

        return [{ tabbarList: resData, sort: resData[0].sort }];
      } else {
        // 该用户无 tab 配置（如切换到无 tab 的用户），清空展示数据
        // 避免上一个用户的 tabBarList/tabFloorList 等残留
        runInAction(() => {
          this.tabBarList = [];
          this.tabFloorList = [];
          this.tabBannerList = [];
          this.tabModuleList = [];
        });
      }
      return null;
    }

    // 直播列表：需要请求蜂鸟直播接口
    if (renderType === 66) {
      if (!resData || resData.length === 0) return [];
      try {
        const userInfo = (Stores.AppMod && Stores.AppMod.userInfo) || {};
        const systemCode = userInfo.belongSystem || 'GONGSI';
        const result = yield Serv.getFengniaoLiveList(systemCode);
        const liveList = (result && result.object) || [];
        return resData.map((item) => ({ ...item, data: liveList }));
      } catch (err) {
        return resData;
      }
    }

    // 资格购商品列表
    if (renderType === 132) {
      if (!resData || resData.length === 0) return [];
      // 取第一条的 linkContent 作为资格购活动 ID
      const firstItem = resData[0] || {};
      const activityId = firstItem.linkContent || null;
      if (activityId) {
        runInAction(() => {
          this.qualificationListActivityId = activityId;
        });
      }
      return [{ activityId, sort: firstItem.sort || 99999 }];
    }

    // 其他类型直接返回
    return resData || [];
  });

  /**
   * 通用的栏位数据加载方法
   * @param {Object} cellConfig - 栏位配置 { servMethod, renderType, mallType }
   * @param {Function} handleMethod - 数据处理方法（pushFloorData）
   */
  loadCellData = flow(function* (cellConfig, handleMethod) {
    const { servMethod, renderType, mallType } = cellConfig;
    try {
      const { data } = yield servMethod(mallType);
      if (data) {
        // 数据预处理
        const processedData = yield this.processCellData(data, renderType);
        if (processedData) {
          handleMethod.call(this, processedData, renderType);
        }
      }
    } catch (err) {
      console.log(`loadCellData ${renderType} err`, err);
    }
  });

  /**
   * 加载所有栏位数据的公共方法
   * @param {Object} options - { mallType, includeTabBar, handleMethod }
   */
  loadAllCellData = flow(function* ({ mallType, includeTabBar = true, handleMethod }) {
    const handler = handleMethod || this.pushFloorData.bind(this);

    const cellConfigs = [
      { servMethod: Serv.getRecommender, renderType: 1, mallType }, // 推荐位
      { servMethod: Serv.getThreeImgs, renderType: 2, mallType }, // 三位图
      { servMethod: Serv.getImgText, renderType: 3, mallType }, // 图文推荐
      { servMethod: Serv.getClassify, renderType: 4, mallType }, // 分类推荐
      { servMethod: Serv.getAdvPicture, renderType: 5, mallType }, // 广告图
      { servMethod: Serv.getProductFloor, renderType: 6, mallType }, // 产品楼层
      { servMethod: Serv.getTitleGuide, renderType: 7, mallType }, // 标题
      { servMethod: Serv.getRecommendProduct, renderType: 8, mallType }, // 产品推荐
      { servMethod: Serv.getCarousel, renderType: 50, mallType }, // 轮播图
      { servMethod: Serv.getHealthTimeLine, renderType: 23, mallType }, // 健康时刻表
      { servMethod: Serv.getLiveUi, renderType: 66, mallType }, // 直播列表
      { servMethod: Serv.getHotRecommend, renderType: 88, mallType }, // 热卖宫格
      { servMethod: Serv.getCombinedRecommend, renderType: 117, mallType } // 组合推荐位
    ];

    if (Stores.AppMod.token) {
      // 资格购商品列表
      cellConfigs.push({ servMethod: Serv.getQualificationItemList, renderType: 132, mallType });
    }

    if (includeTabBar) {
      cellConfigs.push({ servMethod: Serv.getTabBar, renderType: 24, mallType }); // TabBar
    }

    const promises = cellConfigs.map((config) => this.loadCellData(config, handler));
    yield Promise.all(promises);
  });

  /**
   * 获取TabBar数据（已废弃，由 loadCellData 统一处理）
   */
  getTabBar = flow(function* (mallType) {
    // 此方法保留用于兼容，实际逻辑已移至 processCellData
    try {
      const { data } = yield Serv.getTabBar(mallType);
      if (data) {
        const processedData = yield this.processCellData(data, 24);
        if (processedData) {
          this.pushFloorData(processedData, 24);
        }
      }
    } catch (err) {
      console.log('getTabBar err', err);
    }
  });

  /**
   * 加载Tab对应的Banner数据
   * @param {number} mallType - 商城类型
   * @param {boolean} updateState - 是否更新当前显示的banner状态，默认false（只缓存不更新显示）
   */
  loadTabBanner = flow(function* (mallType, updateState = false) {
    // 如果已经有缓存，直接返回
    if (this.tabBannerCache[mallType]) {
      if (updateState) {
        runInAction(() => {
          this.tabBannerList = [...this.tabBannerCache[mallType]];
        });
      }
      return this.tabBannerCache[mallType];
    }

    try {
      const { data } = yield Serv.getBanner(mallType);
      const bannerData = data || [];

      // 缓存数据
      runInAction(() => {
        this.tabBannerCache[mallType] = bannerData;
        // 只有在updateState=true时才更新当前显示
        if (updateState) {
          this.tabBannerList = [...bannerData];
        }
      });

      return bannerData;
    } catch (err) {
      console.log('loadTabBanner err', err);
      runInAction(() => {
        this.tabBannerCache[mallType] = [];
      });
      return [];
    }
  });

  /**
   * 加载Tab对应的应用位数据
   * @param {number} mallType - 商城类型
   * @param {boolean} updateState - 是否更新当前显示的应用位状态，默认false（只缓存不更新显示）
   */
  loadTabModule = flow(function* (mallType, updateState = false) {
    // 如果已经有缓存，直接返回
    if (this.tabModuleCache[mallType]) {
      if (updateState) {
        runInAction(() => {
          this.tabModuleList = [...this.tabModuleCache[mallType]];
        });
      }
      return this.tabModuleCache[mallType];
    }

    try {
      const { data } = yield Serv.getApplication(mallType);
      let list = data || [];
      list = list.filter((item) => item.displayMode !== 1);

      // 缓存数据
      runInAction(() => {
        this.tabModuleCache[mallType] = list;
        // 只有在updateState=true时才更新当前显示
        if (updateState) {
          this.tabModuleList = [...list];
        }
      });

      return list;
    } catch (err) {
      console.log('loadTabModule err', err);
      runInAction(() => {
        this.tabModuleCache[mallType] = [];
      });
      return [];
    }
  });

  /**
   * 加载单个tab的数据并缓存
   * @param {number} mallType - 商城类型
   * @param {boolean} updateState - 是否更新当前显示，默认false
   */
  loadSingleTabData = flow(function* (mallType, updateState = false) {
    console.log('loadSingleTabData START', mallType, 'updateState:', updateState);

    // 如果已经有缓存，直接返回
    if (this.tabDataCache[mallType]) {
      console.log('loadSingleTabData from cache', mallType, this.tabDataCache[mallType]);
      // 如果需要更新显示，从缓存更新
      if (updateState) {
        runInAction(() => {
          this.tabFloorList = [...this.tabDataCache[mallType]];
          if (this.tabModuleCache[mallType]) {
            this.tabModuleList = [...this.tabModuleCache[mallType]];
          }
          if (this.tabBannerCache[mallType]) {
            this.tabBannerList = [...this.tabBannerCache[mallType]];
          }
        });
      }
      return;
    }

    // 创建独立的临时数组，避免多个tab并发加载时数据混乱
    const tempFloorList = [];
    // 自定义handler，将数据存入独立的临时数组
    const tempHandler = (data, renderType) => {
      if (Array.isArray(data)) {
        data.forEach((item) => {
          tempFloorList.push({
            ...item,
            renderType
          });
        });
      } else if (data) {
        tempFloorList.push({
          ...data,
          renderType
        });
      }
    };

    console.log('loadSingleTabData loading data for mallType:', mallType);

    // 并行加载栏位数据、应用位数据、Banner数据（只缓存，不更新显示）
    yield Promise.all([
      this.loadAllCellData({
        mallType,
        includeTabBar: false,
        handleMethod: tempHandler
      }),
      this.loadTabModule(mallType, false),
      this.loadTabBanner(mallType, false)
    ]);

    // 排序（不需要去重，因为不同类型的数据都应该显示）
    tempFloorList.sort((pre, next) => pre.sort - next.sort);

    console.log(
      'loadSingleTabData caching for mallType:',
      mallType,
      'items:',
      tempFloorList.length
    );

    // 缓存栏位数据
    runInAction(() => {
      this.tabDataCache[mallType] = tempFloorList;
    });

    // 如果需要更新显示，统一从缓存更新所有数据（栏位、应用位、banner）
    if (updateState) {
      runInAction(() => {
        this.tabFloorList = [...tempFloorList];
        if (this.tabModuleCache[mallType]) {
          this.tabModuleList = [...this.tabModuleCache[mallType]];
        }
        if (this.tabBannerCache[mallType]) {
          this.tabBannerList = [...this.tabBannerCache[mallType]];
        }
      });
    }

    console.log('loadSingleTabData DONE', mallType, 'cached items:', tempFloorList.length);
  });

  /**
   * 预加载所有tab的数据
   * 优先加载当前选中的tab，再并行加载其他tab
   */
  preloadAllTabsData = flow(function* () {
    const { tabBarList, initialPage } = this;
    if (tabBarList.length <= 0) return;

    console.log('preloadAllTabsData begin', tabBarList.length);

    const currentTab = tabBarList[initialPage];
    const otherTabs = tabBarList.filter((_, idx) => idx !== initialPage);

    // 先加载当前选中的tab，保证能先展示
    if (currentTab) {
      console.log('preload current tab first', currentTab.linkRecommandId);
      // updateState=true 表示加载并更新当前显示
      yield this.loadSingleTabData(currentTab.linkRecommandId, true);
      // 初始tab是消费tab时请求累计节省金额
      if (currentTab.linkRecommandId === MallType.CONSUME) {
        this.getQualificationBenefit();
      }
    }

    // 再并行加载其他tab的数据
    // if (otherTabs.length > 0) {
    //   const timer = setTimeout(() => {
    //     timer && clearTimeout(timer);
    //     console.log('preload other tabs', otherTabs.length);
    //     const otherPromises = otherTabs.map((tab) => {
    //       return this.loadSingleTabData(tab.linkRecommandId);
    //     });
    //     Promise.all(otherPromises);
    //   }, 1000);
    // }

    console.log('preloadAllTabsData complete');
  });

  /**
   * 刷新Tab数据（切换Tab时调用）
   */
  refreshTabData = flow(function* () {
    const { tabBarList, initialPage } = this;
    if (tabBarList.length <= 0) return;

    const mallType = tabBarList[initialPage].linkRecommandId;

    // 加载当前tab数据，updateState=true表示更新显示
    yield this.loadSingleTabData(mallType, true);

    // 消费tab时请求累计节省金额
    if (Stores.AppMod.token && mallType === MallType.CONSUME) {
      this.getQualificationBenefit();
    }
  });

  /**
   * 查询累计节省金额
   */
  getQualificationBenefit = flow(function* () {
    try {
      const { data } = yield Serv.getQualificationBenefit();
      if (data) {
        this.totalDiscountAmount = data.totalDiscountAmount;
      }
    } catch (err) {
      console.log('getQualificationBenefit err', err);
    }
  });
}
const shopHomeMod = new ShopHomeMod();
export default shopHomeMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Home/ShopHome/ShopHomeMod.js